module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgdmlld0JveD0iMCAwIDMyIDMyIj4KICAgIDxwYXRoIGQ9Ik0yMi42NjcgNGw3IDYtNyA2IDcgNi03IDZ2LTRoLTMuNjUzbC0zLjc2LTMuNzYgMi44MjctMi44MjcgMi41ODcgMi41ODdoMnYtOGgtMmwtMTIgMTJoLTZ2LTRoNC4zNDdsMTItMTJoMy42NTN2LTR6TTIuNjY3IDhoNmwzLjc2IDMuNzYtMi44MjcgMi44MjctMi41ODctMi41ODdoLTQuMzQ3di00eiI+PC9wYXRoPgo8L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/components/aplayer/assets/shuffle.svg
// module id = +7IQ
// module chunks = 30